/**
 * How development happens на главной (how-dev).
 */

import { useState, useEffect, useRef } from "react";
import ProcessCard from "../components/ProcessCard/ProcessCard";
import { PROCESS_COPY, PROCESS_STEPS } from "../config/process";
import { PROCESS_ICONS } from "../assets/icons/processIcons";
import {
    getInstantMoveCards,
    getProcessArrowDir,
    getProcessTransform,
} from "../utils/processCarousel";
import "./HomeProcess.css";

const PROCESS_MOBILE_MQ = "(max-width: 1100px)";
const PROCESS_CARD_COUNT = PROCESS_STEPS.length;
const ARROW_PREV = "M31 20.5H10M10 20.5L19 11.5M10 20.5L19 29.5";
const ARROW_NEXT = "M10 20.5H31M31 20.5L22 11.5M31 20.5L22 29.5";

function HomeProcess() {
    const [activeStepCard, setActiveStepCard] = useState(0);
    const [instantCards, setInstantCards] = useState(() => new Set());
    const [isNarrowProcess, setIsNarrowProcess] = useState(
        () => typeof window !== "undefined" && window.matchMedia(PROCESS_MOBILE_MQ).matches
    );
    const processCarouselRef = useRef(null);
    const activeStepRef = useRef(0);

    useEffect(() => {
        const mq = window.matchMedia(PROCESS_MOBILE_MQ);
        const onChange = () => setIsNarrowProcess(mq.matches);
        mq.addEventListener("change", onChange);
        return () => mq.removeEventListener("change", onChange);
    }, []);

    useEffect(() => {
        if (instantCards.size === 0) return undefined;
        let innerId = 0;
        const outerId = requestAnimationFrame(() => {
            innerId = requestAnimationFrame(() => {
                setInstantCards(new Set());
            });
        });
        return () => {
            cancelAnimationFrame(outerId);
            cancelAnimationFrame(innerId);
        };
    }, [instantCards]);

    const processStepCount = PROCESS_CARD_COUNT;

    const scrollProcessCard = (index) => {
        const root = processCarouselRef.current;
        if (!root) return;
        const card = root.querySelectorAll(".how-dev-card")[index];
        if (!card) return;
        root.scrollTo({ left: card.offsetLeft, behavior: "smooth" });
    };

    const goToProcessIndex = (index) => {
        const next = Math.max(0, Math.min(index, processStepCount - 1));
        const prev = activeStepRef.current;
        if (!isNarrowProcess && prev !== next) {
            const moves = getInstantMoveCards(prev, next, processStepCount);
            if (moves.size) setInstantCards(moves);
        }
        activeStepRef.current = next;
        setActiveStepCard(next);
        if (isNarrowProcess) scrollProcessCard(next);
    };

    // Переход карточек по стрелке
    const goToCard = (dir) => {
        const count = processStepCount;
        const prev = activeStepRef.current;
        const next = dir === "next" ? (prev + 1) % count : (prev - 1 + count) % count;
        if (!isNarrowProcess && prev !== next) {
            const moves = getInstantMoveCards(prev, next, count);
            if (moves.size) setInstantCards(moves);
        }
        activeStepRef.current = next;
        setActiveStepCard(next);
        if (isNarrowProcess) {
            requestAnimationFrame(() => scrollProcessCard(next));
        }
    };

    const handleProcessScroll = () => {
        const root = processCarouselRef.current;
        if (!root || !isNarrowProcess) return;
        const cards = root.querySelectorAll(".how-dev-card");
        if (!cards.length) return;
        let closest = 0;
        let best = Infinity;
        cards.forEach((card, i) => {
            const dist = Math.abs(card.offsetLeft - root.scrollLeft);
            if (dist < best) {
                best = dist;
                closest = i;
            }
        });
        if (activeStepRef.current !== closest) {
            activeStepRef.current = closest;
            setActiveStepCard(closest);
        }
    };

    return (
                    <>
                    {/* Logo banner */}
                    <div className="how-dev-section">
                        <div className="how-dev-banner" style={{
                            width: '1115px',
                            height: '450px',
                            maxWidth: '100%',
                            padding: '2rem 2.5rem',
                            background: '#F5F5F5',
                            borderRadius: '20px',
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            gap: '1rem',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.06), 0 2px 4px rgba(0, 0, 0, 0.04)',
                        }}>
                            <p style={{
                                margin: 0,
                                maxWidth: '657px',
                                fontFamily: "'Montserrat', sans-serif",
                                fontStyle: 'normal',
                                fontWeight: 700,
                                fontSize: '1.85rem',
                                lineHeight: '1.2',
                                color: '#000000',
                            }}>
                                {PROCESS_COPY.titleLines[0]}<br />{PROCESS_COPY.titleLines[1]}
                            </p>

                            {/* Cards Carousel — 3 visible on desktop, swipe on mobile */}
                            <div
                                ref={processCarouselRef}
                                className="how-dev-carousel"
                                onScroll={handleProcessScroll}
                                style={{
                                    position: 'absolute',
                                    top: '180px',
                                    left: '50%',
                                    marginLeft: '-50vw',
                                    width: '100vw',
                                    height: '172px',
                                    overflow: 'hidden',
                                }}
                            >
                                {PROCESS_STEPS.map((step, index) => {
                                    const Icon = PROCESS_ICONS[index];
                                    return (
                                        <ProcessCard
                                            key={step.number}
                                            icon={<Icon />}
                                            number={step.number}
                                            title={step.title}
                                            text={step.text}
                                            transform={getProcessTransform(index, activeStepCard, PROCESS_CARD_COUNT)}
                                            skipTransition={instantCards.has(index)}
                                            arrowPath={getProcessArrowDir(index, activeStepCard, PROCESS_CARD_COUNT) === "prev" ? ARROW_PREV : ARROW_NEXT}
                                            onArrowClick={() => goToCard(getProcessArrowDir(index, activeStepCard, PROCESS_CARD_COUNT))}
                                        />
                                    );
                                })}
                            </div>{/* end carousel container */}

                        {/* Step dot indicators */}
                        <div className="how-dev-dots" style={{
                            position: 'absolute',
                            top: '380px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            display: 'flex',
                            gap: '8px',
                            alignItems: 'center',
                        }}>
                        {Array.from({ length: processStepCount }, (_, i) => (
                            <div
                                key={i}
                                onClick={() => goToProcessIndex(i)}
                                    style={{
                                        width: activeStepCard === i ? '24px' : '8px',
                                        height: '8px',
                                        borderRadius: '4px',
                                        background: activeStepCard === i ? '#B8FF65' : '#CCCCCC',
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer',
                                    }}
                                />
                        ))}
                        </div>
                        </div>
                    </div>
                    </>
    );
}

export default HomeProcess;
// pages/HomeProcess.js
